export const services = [
  {
    title: "Tender Alerts & Notifications",
    icon: "/icons/TenderAlert.png",
    desc:
      "Get unlimited access to all relevant tender notices for the product or service category you are interested in. Subscribe to our daily email alerts or simply access our portal at will. Gain easy access to scanned copies of tenders published in newspapers or websites along with every other pertinent information you need to be aware of."
  },
  {
    title: "Pre-qualification Terms",
    icon: "/icons/PreQualification.png",
    desc:
      "Capture pre-qualification conditions as specified in the tender document. Focus on the right opportunity at the right time. Save valuable time, effort and opportunity cost by making an informed decision whether to bid for a given tender or shift the focus on a more appropriate one."
  },
  {
    title: "Tender Documents",
    icon: "/icons/Documents.png",
    desc:
      "Get complete set of tender information at a single place without having to hop from a website to another, saving valuable time and resources which could potentially be invested in winning the contracts instead."
  },
  {
    title: "Quick Filters & Optimized Results",
    icon: "/icons/Filters.png",
    desc:
      "Play around with our carefully chosen set of quick filters and customize options to have results displayed the way you prefer."
  },
  {
    title: "Historical Tender Records",
    icon: "/icons/History.png",
    desc:
      "Maintain and keep track of historical data and tender records of the past. Identify useful trends, patterns and valuable insights and utilize abundant knowledge of the past to meticulously plan for the future."
  },
  {
    title: "Digital Certificates",
    icon: "/icons/Certificate.png",
    desc:
      "Major government bodies have already switched to eTendering, eAuctions, Reverse Auctions, etc. You need a valid Class-3 Digital Certificate to participate in such opportunities. We also provide assistance in procuring digital certificate from the certifying agency of your choice. Get end-to-end support in terms of installation and configuration of digital certificate."
  },
  {
    title: "Upcoming Tender Information",
    icon: "/icons/Upcoming.png",
    desc:
      "Harness our knowledge to the best of your advantage. Track thousands of new projects announced by the government and private sector companies across India involving huge investments and opportunities worth zillions."
  },
  {
    title: "Open Access to Tender Marketplace",
    icon: "/icons/Marketplace.png",
    desc:
      "Get benefitted from the open and unlimited access to the tender marketplace, explore new opportunities and chart new avenues for growth."
  }
];


export const keywordList = [
  "Road",
  "Constructions",
  "Electronics",
  "Software",
  "Food",
  "Civil",
  "Repairing",
  "Electrical",
  "Sanitation",
  "Water Supply"
];

export const stateList = [
  "Kerala",
  "Karnataka",
  "Road",
  "Constructions",
  "Electronics",
  "Software",
  "Food",
  "Civil",
  "Repairing",
  "Electrical",
  "Sanitation",
  "Water Supply"
];



export const TIMELINE_ITEMS = [
  {
    icon: "/icons/published.png",
    label: "Published",
    date: "24 Oct 2025",
    status: "completed"
  },
  {
    icon: "/icons/prebid.png",
    label: "Pre-bid Meeting",
    date: "24 Oct 2025",
    status: "current"
  },
  {
    icon: "/icons/submission.png",
    label: "Submission Deadline",
    date: "24 Oct 2025",
    status: "upcoming-orange"
  },
  {
    icon: "/icons/technical.png",
    label: "Technical Opening",
    date: "24 Oct 2025",
    className: "technical-award"
  },
  {
    icon: "/icons/award.png",
    label: "Award Date",
    date: "TBA",
    className: "technical-award"
  }
];

export const bidders = [
  {
    rank: "L1",
    name: "Semiconductors Limited",
    techStatus: "Qualified",
    finStatus: "Opened",
    amount: "₹1,90,00,000",
    remarks: "Awarded"
  },
  {
    rank: "-",
    name: "Conductors Limited",
    techStatus: "Disqualified",
    finStatus: "-",
    amount: "₹1,90,00,000",
    remarks: "Failed Technical"
  },
  {
    rank: "L2",
    name: "ABC Limited",
    techStatus: "Qualified",
    finStatus: "Rejected",
    amount: "₹2,40,00,000",
    remarks: "Failed Financial"
  },
  {
    rank: "L3",
    name: "Company 4",
    techStatus: "Qualified",
    finStatus: "Opened",
    amount: "₹2,14,00,000",
    remarks: "-"
  },
  {
    rank: "L4",
    name: "Company 5",
    techStatus: "Qualified",
    finStatus: "Opened",
    amount: "₹2,16,00,000",
    remarks: "-"
  },
  {
    rank: "L5",
    name: "Company 6",
    techStatus: "Qualified",
    finStatus: "Opened",
    amount: "₹2,18,00,000",
    remarks: "-"
  },
  {
    rank: "L6",
    name: "Company 7",
    techStatus: "Qualified",
    finStatus: "Opened",
    amount: "₹2,20,00,000",
    remarks: "-"
  },
  {
    rank: "L7",
    name: "Company 8",
    techStatus: "Qualified",
    finStatus: "Opened",
    amount: "₹2,22,00,000",
    remarks: "-"
  },
  {
    rank: "L8",
    name: "Company 9",
    techStatus: "Qualified",
    finStatus: "Rejected",
    amount: "₹2,25,00,000",
    remarks: "Failed Financial"
  },
  {
    rank: "L9",
    name: "Company 10",
    techStatus: "Qualified",
    finStatus: "Opened",
    amount: "₹2,30,00,000",
    remarks: "-"
  }
];



export const TENDERS = [
  {
    id: "BEL-CP-2025-001",
    title: "Fabrication & Supply of Control Panels",
    status: "Live",
    department: "Bharat Electronics Limited (BEL)",
    ministry: "Ministry of Defence",
    location: "Bangalore, India",
    tenderValue: "₹2,40,00,000",
    resultStatus: "Awarded",
    category: "Electronics",
    estimatedBidValue: "₹2,40,00,000",
    awardedTo: "Semiconductors Limited",
    awardedValue: "₹1,90,00,000",
    emd: "₹2,40,000",
    submissionDeadline: "10/01/2026",
    daysLeft: 20,
    mseExemption: "-",
    startupExemption: "-",
    stats: {
      views: 1247,
      interested: 89,
      applies: 156,
    },
    shortlistSummary: {
      technicalStatus: "QUALIFIED",   // enum
      rank: "L2",                     // string
      expired: true                   // boolean
    },
    isApplied: true,
    isFavourite: false,
    isShortlisted: true,
    bidValue: "₹2,40,00,000",
    submittedOn: "22/12/2025",
    applicationStatus: "Pending Review",
    applicationStatusLabel: "Pending Review",
    quickFacts: [
      { label: "Tender ID", value: "BEL/CTRL/2025/0178" },
      { label: "Estimated Value", value: "₹2,40,00,000" },
      { label: "Category", value: "Electronics" },
      { label: "EMD", value: "₹4,80,000" },
      { label: "Procurement Type", value: "Goods" },
      { label: "Procurement Source", value: "eProcure" },
      { label: "Document Fee", value: "₹1,500" },
      { label: "Published", value: "24 Oct 2025" },
    ],
    description: `Bharat Electronics Limited (BEL) invites sealed tenders for the fabrication
      and supply of control panels for various electronic systems. The scope
      includes design, manufacturing, testing, and delivery of high-quality
      control panels meeting BEL specifications.`,
    descriptionCards: [
      { label: "Eligibility", value: "ISO certified manufacturers with 3+ years experience" },
      { label: "Delivery Period", value: "120 days from order date" },
      { label: "Warranty", value: "24 months comprehensive" },
    ],
    eligibility: [
      "ISO 9001:2015 Certification",
      "Minimum 3 years experience",
      "Annual turnover ≥ ₹5 Cr",
      "Valid GST Registration",
      "PAN card mandatory",
      "Bank guarantee facility",
      "Technical capability certificate",
      "Past performance record",
    ],
    relatedTenders: [
      {
        title: "Supply of Electronic Components",
        org: "Defence Research and Development Organization",
        location: "Delhi",
        date: "06 November 2025",
        daysLeft: "5 days left",
        danger: true,
      },
      {
        title: "Maintenance of Control Systems",
        org: "Hindustan Aeronautics Limited",
        location: "Bengaluru",
        date: "17 November 2025",
        daysLeft: "15 days left",
      },
      {
        title: "Testing Equipment Supply",
        org: "Bharat Heavy Electricals Limited",
        location: "Haridwar",
        date: "17 November 2025",
        daysLeft: "15 days left",
      },
    ],
    documents: [
      { title: "Tender Document", icon: "pdf", meta: "PDF · 2.4 MB · 24 Oct 2025" },
      { title: "Technical Specifications", icon: "pdf", meta: "PDF · 1.8 MB · 24 Oct 2025" },
      { title: "Bill of Quantities (BOQ)", icon: "exel", meta: "XLSX · 0.5 MB · 24 Oct 2025" },
    ],
    corrigendum: [
      { title: "Corrigendum 1", meta: "Date extension notice", icon: "warning" },
    ],

  },

];




export const FEATURES_DATA = [
  {
    title: "Quick Filters & Optimized Results",
    icon: "/images/searchi.svg",
    desc: "Use smart filters and advanced sorting to quickly narrow down tenders and view results that best match your business needs."
  },
  {
    title: "Upcoming Tender Alerts",
    icon: "/images/cartd.svg",
    desc: "Harness our knowledge to the best of your advantage. Track thousands of new projects announced by the government and private sector companies across India involving huge investments."
  },
  {
    title: "Open Tender Marketplace",
    icon: "/images/carti.svg",
    desc: "Get benefitted from the open and unlimited access to the tender marketplace, explore new opportunities and chart new avenues for growth."
  },
  {
    title: "Complete Tender Documents",
    icon: "/images/complete-tender.png",
    desc: "Get complete set of tender information at a single place without having to hop from a website to another, saving valuable time and resources which could potentially be invested in winning the contracts instead."
  }
];

// Related tenders carousel data
export const RELATED_TENDERS_DATA = [
  {
    title: "Bharat Electronics Limited (BEL)",
    img: "/images/bel.webp",
    ofc: "Ministry of Defence",
    date: "10 November 2025",
    loc: "Bangalore",
  },
  {
    title: "Bharat Electronics Limited (BEL)",
    img: "/images/bel.webp",
    ofc: "Ministry of Defence",
    date: "10 November 2025",
    loc: "Bangalore",
  },
  {
    title: "Bharat Electronics Limited (BEL)",
    img: "/images/bel.webp",
    ofc: "Ministry of Defence",
    date: "10 November 2025",
    loc: "Bangalore",
  },
  {
    title: "Bharat Electronics Limited (BEL)",
    img: "/images/bel.webp",
    ofc: "Ministry of Defence",
    date: "10 November 2025",
    loc: "Bangalore",
  }, {
    title: "Bharat Electronics Limited (BEL)",
    img: "/images/bel.webp",
    ofc: "Ministry of Defence",
    date: "10 November 2025",
    loc: "Bangalore",
  }, {
    title: "Bharat Electronics Limited (BEL)",
    img: "/images/bel.webp",
    ofc: "Ministry of Defence",
    date: "10 November 2025",
    loc: "Bangalore",
  }
];

// Organization carousel data
export const ORGANIZATION_DATA = [
  {
    title: "Indian Railways",
    img: "/images/irl.webp",
    ofc: "1,200 Tenders",
  },
  {
    title: "Indian Railways",
    img: "/images/irl.webp",
    ofc: "1,200 Tenders",
  },
  {
    title: "Indian Railways",
    img: "/images/irl.webp",
    ofc: "1,200 Tenders",
  },
  {
    title: "Indian Railways",
    img: "/images/irl.webp",
    ofc: "1,200 Tenders",
  }, {
    title: "Indian Railways",
    img: "/images/irl.webp",
    ofc: "1,200 Tenders",
  },
  {
    title: "Indian Railways",
    img: "/images/irl.webp",
    ofc: "1,200 Tenders",
  }
];

// Ministry carousel data
export const MINISTRY_DATA = [
  {
    title: "Indian Railways",
    img: "/images/flg.webp",
    ofc: "1,200 Tenders",
  },
  {
    title: "Indian Railways",
    img: "/images/flg.webp",
    ofc: "1,200 Tenders",
  },
  {
    title: "Indian Railways",
    img: "/images/flg.webp",
    ofc: "1,200 Tenders",
  },
  {
    title: "Indian Railways",
    img: "/images/flg.webp",
    ofc: "1,200 Tenders",
  }, {
    title: "Indian Railways",
    img: "/images/flg.webp",
    ofc: "1,200 Tenders",
  },
  {
    title: "Indian Railways",
    img: "/images/flg.webp",
    ofc: "1,200 Tenders",
  }
];


// States carousel data
export const STATE_DATA = [
  {
    title: "Uttar Pradesh",
    img: "/images/taj.webp",
    ofc: "1,200 Tenders",
  },
  {
    title: "Uttar Pradesh",
    img: "/images/taj.webp",
    ofc: "1,200 Tenders",
  },
  {
    title: "Uttar Pradesh",
    img: "/images/taj.webp",
    ofc: "1,200 Tenders",
  },
  {
    title: "Uttar Pradesh",
    img: "/images/taj.webp",
    ofc: "1,200 Tenders",
  }, {
    title: "Uttar Pradesh",
    img: "/images/taj.webp",
    ofc: "1,200 Tenders",
  },
  {
    title: "Uttar Pradesh",
    img: "/images/taj.webp",
    ofc: "1,200 Tenders",
  }

];
